module.exports = __webpack_public_path__ + "img/circle-left-bottom.bdd6e753.png";